import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Divider,
  Button,
  CircularProgress,
  LinearProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import HomeIcon from "@mui/icons-material/Home";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useNavigate, useParams } from "react-router-dom";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import { useWebSocket } from "../../Websocket/useWebSocket";
import { useSelector } from "react-redux";

const VendingProgress = () => {
  const navigate=useNavigate()
  const ReduxWebSocketData = useSelector(
    (state) => state.WebSocket?.WebSocketData
  );

  const handleClose=()=>{
    navigate(`/`)
  }
  const { wsData, startWebSocket } = useWebSocket();
  const { orderId } = useParams();
  const { makeApiRequest } = useApiRequest();

  const token = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("deviceId");

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [websocketActive, setWebsocketActive] = useState(false);

const handleSupport=()=>{
    navigate(`/ordersearch?id=${orderId}`)
}

  const handleHome=()=>{
    navigate('/')
  }
  // ✅ Fetch order details
  const fetchOrderDetails = () => {
    if (!token || !orderId) return;

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/order/${orderId}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      handleSuccess: (res) => {
        const data = res?.data?.data || {};
        const expanded =
          data.lineItems?.flatMap((item) =>
            Array.from({ length: item.unitCount || 1 }, (_, i) => ({
              ...item,
              progress: 0,
              success: null,
              uniqueKey: `${item.id}-${i + 1}`,
            }))
          ) || [];
        setItems(expanded);
        setLoading(false);

        // ✅ Check Redux WebSocket first
        if (ReduxWebSocketData && Object.keys(ReduxWebSocketData).length > 0) {
          //console.log("🟢 Using Redux WebSocket data:", ReduxWebSocketData);
          handleWebSocketData(ReduxWebSocketData);
        } else {
          //console.log("🟡 No Redux data, starting local WebSocket…");
          startWebSocketConnection(orderId);
          setWebsocketActive(true);
        }
      },
      handleError: (err) => {
        console.error("❌ Fetch Order Error:", err);
        setLoading(false);
      },
    });
  };

  // ✅ WebSocket connection (local)
  const startWebSocketConnection = (orderId) => {
    const wsUrl = `wss://api-stage.daalchini.co.in/consumerbe/status/payment?order_id=${orderId}`;

    startWebSocket(wsUrl, (data) => {
      //console.log("🔸 Local WebSocket Received:", data);
      handleWebSocketData(data);
    });
  };

  // ✅ Shared handler for WebSocket updates
  const handleWebSocketData = (data) => {
    const lineItem = data?.lineItem || data;
    if (!lineItem?.id) return;

    setItems((prevItems) => {
      const updated = [...prevItems];
      const index = updated.findIndex(
        (i) => i.id === lineItem.id && i.success === null
      );

      if (index !== -1) {
        updated[index] = {
          ...updated[index],
          progress: 100,
          success: lineItem.success,
        };
      }
      return updated;
    });
  };

  // ✅ Watch Redux WebSocket updates dynamically
  useEffect(() => {
    if (ReduxWebSocketData && Object.keys(ReduxWebSocketData).length > 0) {
     // console.log("🔹 Redux WebSocket Data Changed:", ReduxWebSocketData);
      handleWebSocketData(ReduxWebSocketData);
    }
  }, [ReduxWebSocketData]);

  useEffect(() => {
    fetchOrderDetails();
  }, [orderId]);

  // ✅ Overall progress
  const totalProgress =
    items.length > 0
      ? items.reduce((sum, item) => sum + (item.progress || 0), 0) /
        items.length
      : 0;

  if (loading) {
    return (
      <Box
        height="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={2}
        sx={{
          background: "#fae14b",
          position: "fixed",
          width: "100%",
          zIndex: 999,
          top: 0,
         
        }}
      >
        <Box display="flex" alignItems="center">
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" sx={{ fontWeight: 500, ml: 1 }}>
            Match The Number
          </Typography>
        </Box>
      </Box>
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
         paddingTop:"66px"
      }}

    >
      {/* 🔹 Top Progress Bar */}
      <LinearProgress
        variant="determinate"
        value={totalProgress}
        sx={{
          height: 6,
          backgroundColor: "#f0f0f0",
          "& .MuiLinearProgress-bar": {
            backgroundColor: "#FCD947",
          },
        }}
      />

  


      {/* Order Info */}
      <Box
        sx={{
         
          px: 2,
          py: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography variant="body2" sx={{ color: "#555" }}>
            Order ID:{" "}
            <Typography
              component="span"
              sx={{ color: "#1a237e", fontWeight: 600 }}
            >
              {orderId}
            </Typography>
          </Typography>
          <Typography variant="body2" sx={{ color: "#555", mt: 0.5 }}>
            Number Of Products:{" "}
            <Typography
              component="span"
              sx={{ color: "#1a237e", fontWeight: 600 }}
            >
              {items?.length || 0}
            </Typography>
          </Typography>
        </Box>

        {/* ✅ Circular Progress */}
        <Box position="relative" display="inline-flex">
          <CircularProgress
            variant="determinate"
            value={100}
            size={55}
            thickness={4}
            sx={{ color: "#e0e0e0", position: "absolute", left: 0 }}
          />
          <CircularProgress
            variant="determinate"
            value={totalProgress}
            size={55}
            thickness={4}
            sx={{ color: "#338c0aff" }}
          />
          <Box
            top={0}
            left={0}
            bottom={0}
            right={0}
            position="absolute"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography variant="body2" sx={{ fontWeight: 600, color: "#000" }}>
              {Math.round(totalProgress)}%
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider />

      {/* Product List */}
      <Box flexGrow={1} overflow="auto" sx={{ px: 2, py: 1 }}>
        {items.map((item) => (
          <Box
            key={item.uniqueKey}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{ py: 1.5, borderBottom: "1px solid #eee" }}
          >
            <Box display="flex" alignItems="center">
              <img
                src={
                  item.imageUrl?.startsWith("http")
                    ? item.imageUrl
                    : `https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${item.imageUrl}`
                }
                alt={item.productName}
                width="50"
                height="50"
                style={{
                  borderRadius: "8px",
                  marginRight: "12px",
                  objectFit: "cover",
                }}
                onError={(e) => {
                  e.target.src = "https://via.placeholder.com/50?text=No+Image";
                }}
              />
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>
                  {item.productName}
                </Typography>
                <Typography variant="body2" sx={{ color: "#444" }}>
                  ₹{item.offerPrice.toFixed(2)}
                </Typography>
              </Box>
            </Box>

            {item.success === true ? (
              <CheckCircleIcon sx={{ color: "#4caf50", fontSize: 30 }} />
            ) : item.success === false ? (
              <CancelIcon sx={{ color: "#f44336", fontSize: 30 }} />
            ) : (
              <CircularProgress
                size={30}
                thickness={4}
                sx={{ color: "#fbc02d" }}
              />
            )}
          </Box>
        ))}
      </Box>

      {/* Footer */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          borderTop: "1px solid #ddd",
          py: 2,
        }}
      >
        <Button
        onClick={(e)=>{handleHome()}}
          variant="outlined"
          startIcon={<HomeIcon />}
          sx={{
            color: "#009688",
            borderColor: "#009688",
            textTransform: "none",
            fontWeight: 600,
            width: "40%",
          }}
        >
          Home
        </Button>
        <Button
          onClick={(e)=>{handleSupport()}}
          variant="contained"
          startIcon={<HeadsetMicIcon />}
          sx={{
            backgroundColor: "#e0f2f1",
            color: "#009688",
            textTransform: "none",
            fontWeight: 600,
            width: "40%",
            boxShadow: "none",
            "&:hover": { backgroundColor: "#d0ece9" },
          }}
        >
          Help
        </Button>
      </Box>
    </Box>
    </>
  );
};

export default VendingProgress;
